<script>
    import {fade} from 'svelte/transition';
    import app from "../stores/app";
</script>

{#if $app.page_loader}
    <div class="page-loader" out:fade="{{ duration: 1500 }}">
        <div class="line"></div>
    </div>
{/if}

<style>
    .page-loader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        height: 0;
        z-index: 9999;
    }

    .page-loader .line {
        display: block;
        position: absolute;
        width: 500px;
        height: 5px;
        top: 0;
        background: rgb(3, 169, 244);
        background: linear-gradient(270deg, rgba(3, 169, 244, 1) 0%, rgba(3, 169, 244, 1) 53%, rgba(3, 169, 244, 0) 100%);
        animation: leftToRight 4s;
        animation-iteration-count: infinite;
    }

    @keyframes leftToRight {
        from {
            transform: translateX(calc(0vw - 500px));
        }
        to {
            transform: translateX(100vw);
        }
    }
</style>